<div class="container">
  <mat-card class="militar-info">
    <h2>Dados do Militar</h2>
    <div class="info-column">
      <span><strong>Matrícula:</strong> {{ beneficiario.matricula }}</span>
      <span><strong>Nome:</strong> {{ beneficiario.nome }}</span>
      <span><strong>ID Funcional:</strong> {{ beneficiario.idFuncional }}</span>
      <span><strong>CPF:</strong> {{ beneficiario.cpf }}</span>
      <span><strong>Órgão:</strong> {{ beneficiario.orgao.sigla }}</span>
    </div>
  </mat-card>

  <app-etapas-beneficio [etapaSelecionada]="6"></app-etapas-beneficio>

  <h1 class="page-title">Acréscimos Previdenciários</h1>

  <mat-card class="tabela-card">
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <table
      mat-table
      [dataSource]="acrescimos"
      class="mat-elevation-z2"
      *ngIf="!loading"
    >
      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let a">
          {{ a.enumTipoAcrescimoPrevidenciario.descricao }}
        </td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef>Descrição</th>
        <td mat-cell *matCellDef="let a">{{ a.instituicaoExterna?.descricao || beneficiario.orgao.descricao || beneficiario.orgao.sigla }}</td>
      </ng-container>

      <ng-container matColumnDef="inicio">
        <th mat-header-cell *matHeaderCellDef>Início</th>
        <td mat-cell *matCellDef="let a">
          {{ a.dataInicio | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fim">
        <th mat-header-cell *matHeaderCellDef>Fim</th>
        <td mat-cell *matCellDef="let a">
          {{ a.dataFim | date : "dd/MM/yyyy" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="totalDias">
        <th mat-header-cell *matHeaderCellDef>Total Dias</th>
        <td mat-cell *matCellDef="let a">{{ a.qtdDiasAcrecimo }}</td>
      </ng-container>

      <ng-container matColumnDef="diasAcrescentar">
        <th mat-header-cell *matHeaderCellDef>Dias a Acrescentar</th>
        <td mat-cell *matCellDef="let a">{{ a.diasAcrescentar }}</td>
      </ng-container>

      <ng-container matColumnDef="diasDeduzir">
        <th mat-header-cell *matHeaderCellDef>Dias a Deduzir</th>
        <td mat-cell *matCellDef="let a">{{ a.diasDeduzir }}</td>
      </ng-container>
<!--
      <ng-container matColumnDef="totalAproveitado">
        <th mat-header-cell *matHeaderCellDef>Total Aproveitado</th>
        <td mat-cell *matCellDef="let a">{{ calcularTotal(a) }}</td>
      </ng-container>
-->
      <ng-container matColumnDef="totalAproveitado">
        <th mat-header-cell *matHeaderCellDef>Total Aproveitado</th>
        <td mat-cell *matCellDef="let a">{{ a.qtdDiasAcrescidos }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let a">
          {{ a.statusDoc || getStatus(a) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let a">
<button mat-icon-button matTooltip="Detalhar e editar repasses" (click)="editarRepasses(a)"><mat-icon>payments</mat-icon></button>

          <!-- Upload -->
          <button
            mat-icon-button
            (click)="abrirModalUpload(a)"
            matTooltip="Anexar Documento"
          >
            <mat-icon color="primary">upload_file</mat-icon>
          </button>

          <!-- Download -->
          <button
            mat-icon-button
            (click)="downloadFile(a)"
            matTooltip="Baixar Documento"
            [disabled]="!(a.hashDoc || a.hash)"
          >
            <mat-icon>download</mat-icon>
          </button>

          <!-- Delete -->
          <button
            mat-icon-button
            (click)="deletarDocumento(a)"
            matTooltip="Excluir Documento"
            [disabled]="!(a.hashDoc || a.hash)"
          >
            <mat-icon color="warn">delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </mat-card>

  <p *ngIf="erroResumo" role="alert">{{ erroResumo }}</p>
  <table *ngIf="resumo" class="resumo-tempos">
    <thead><tr><th>Total de dias concomitantes</th><th>Total líquido</th></tr></thead>
    <tbody><tr><td>{{ resumo.totalDiasConcomitantes }}</td><td>{{ resumo.totalLiquido }}</td></tr></tbody>
  </table>
  <div class="acoes-atualizacao">
    <button mat-flat-button color="primary" (click)="atualizarDados()" [disabled]="loading || atualizando">
      {{ atualizando ? 'Atualizando...' : 'Atualizar e Salvar Dados' }}
    </button>
  </div>

  <!-- Modal Upload -->
  <ng-template #modalUpload let-data>
    <h2 mat-dialog-title>Anexar Documento</h2>
    <mat-dialog-content class="upload-content">
      <p><strong>Comprovação Acréscimo</strong></p>
      <p>Envie um arquivo PDF referente ao acréscimo selecionado.</p>

      <div class="upload-row">
        <input
          type="file"
          accept="application/pdf"
          hidden
          #fileInput
          (change)="onFileSelected($event)"
        />
        <button mat-stroked-button color="primary" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon> Procurar PDF
        </button>
        <span class="file-name" *ngIf="selectedFile">{{
          selectedFile.name
        }}</span>
      </div>

      <mat-progress-bar
        *ngIf="uploading"
        mode="indeterminate"
      ></mat-progress-bar>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions">
      <button mat-stroked-button mat-dialog-close [disabled]="uploading">
        <mat-icon>close</mat-icon> Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        (click)="enviarDocumento()"
        [disabled]="!selectedFile || uploading"
      >
        <mat-icon>cloud_upload</mat-icon> Enviar
      </button>
    </mat-dialog-actions>
  </ng-template>
</div>
